module.exports = __webpack_public_path__ + "static/media/kudos-commnet-emoji-icon.b1334dce.svg";